import api from "../../index";

export const GetAllwalletinternalTransferApi = (params) => api.get(`Admin/GetAll-InternalTransfers?${params}`);
export const InternalTransferRequestAcceptRejectApi = (data) => api.post('WalletMaster/Approve-Reject-Internal-Transfer-Request', data);
export const GetAllAverageScalpingApi = (params) => api.get(`IBMaster/GetAll-Average-Scalping-Deal/${params}`);